import { useState, useEffect } from 'react';
import { getHeadersUnwrapped, searchUserByFirstName, useUserContext } from '..';
import { compose as lcompose } from 'lodash/fp';

export const useFirstNameSearch = () => {
  const { user } = useUserContext();

  const [input, setInput] = useState('');
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    lcompose(
      searchUserByFirstName,
      getHeadersUnwrapped
    )(user)(input).then(setOptions);
  }, [input, user]);

  return {
    users: options,
    firstNameSearchInput: input,
    setFirstNameSearchInput: setInput,
  };
};
